import axios from 'axios'
import { getStoredOpenId } from '../utils/wechat'

const baseURL = '/api'

const instance = axios.create({
  baseURL,
  timeout: 30000,
  withCredentials: true
})

instance.interceptors.request.use(config => {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('adminToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    const openId = getStoredOpenId()
    if (openId) {
      config.headers['X-WeChat-OpenId'] = openId
    }
  } catch (e) {
    console.warn('localStorage access error:', e)
  }
  return config
})

instance.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export const authAPI = {
  login: (data) => instance.post('/auth/login', data),
  register: (data) => instance.post('/auth/register', data)
}

export const taskAPI = {
  getTasks: () => instance.get('/tasks'),
  getTask: (id) => instance.get(`/tasks/${id}`),
  createTask: (data) => instance.post('/tasks', data),
  updateTask: (id, data) => instance.put(`/tasks/${id}`, data),
  deleteTask: (id) => instance.delete(`/tasks/${id}`)
}

export const submissionAPI = {
  create: (data, userId) => instance.post('/submissions', data, { 
    headers: { userId },
    timeout: 30000
  }),
  getList: (params) => instance.get('/submissions', { params }),
  getDetail: (id) => instance.get(`/submissions/${id}`),
  getReviewStatus: (id, userId) => instance.get(`/submissions/${id}/review-status`, { params: { userId } }),
  getStatusByUser: (userId, taskId) => instance.get('/submissions/status/by-user', { params: { userId, taskId } }),
  getMyLatestStatus: (taskId) => instance.get('/submissions/status/my-latest', { params: { taskId } }),
  getPendingByUser: (userId) => instance.get('/submissions/status/pending', { params: { userId } }),
  getApprovedByUser: (userId) => instance.get('/submissions/status/approved', { params: { userId } }),
  getRejectedByUser: (userId) => instance.get('/submissions/status/rejected', { params: { userId } }),
  requestManualReview: (id, userId) => instance.post(`/submissions/${id}/request-manual-review`, null, { params: { userId } }),
  review: (id, data) => instance.put(`/submissions/${id}/review`, data)
}

export const uploadAPI = {
  images: (formData) => instance.post('/upload/images', formData, {
    timeout: 60000
  })
}

export const profileAPI = {
  changePassword: (data) => instance.put('/profile/change-password', data)
}

export const wechatAPI = {
  authorize: () => '/api/wechatauth/authorize',
  getPublicConfig: () => instance.get('/wechatauth/public-config'),
  getCurrentOpenId: () => instance.get('/wechatauth/current-openid'),
  resolveEntry: (openid, appId, returnUrl = '/') =>
    instance.get('/wechatauth/resolve-entry', { params: { openid, appId, returnUrl } }),
  getUserInfo: (userId) => instance.get(`/wechatauth/userinfo/${userId}`)
}

export const wechatMenuAPI = {
  getMenus: () => instance.get('/wechat-menu'),
  createMenu: (data) => instance.post('/wechat-menu', data),
  updateMenu: (id, data) => instance.put(`/wechat-menu/${id}`, data),
  deleteMenu: (id) => instance.delete(`/wechat-menu/${id}`),
  publishMenu: () => instance.post('/wechat-menu/publish'),
  deleteOrphans: () => instance.delete('/wechat-menu/orphans')
}

export const wechatKeywordReplyAPI = {
  getAll: () => instance.get('/wechat-keyword-reply'),
  create: (data) => instance.post('/wechat-keyword-reply', data),
  update: (id, data) => instance.put(`/wechat-keyword-reply/${id}`, data),
  delete: (id) => instance.delete(`/wechat-keyword-reply/${id}`)
}
